exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".paused[data-v-327fe5f8] {\n  opacity: 0.5;\n}\n", ""]);

